var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"inline-flex"},attrs:{"className":"flex-wrap"}},[_c('search-nav-start-end',{attrs:{"label":"작성일"},model:{value:(_vm.nav.created_at),callback:function ($$v) {_vm.$set(_vm.nav, "created_at", $$v)},expression:"nav.created_at"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }